const breakpointPrefixes = {
  MAX_XL: 'max-xl',
  MAX_MD: 'max-md',
};

const breakpointKeys = {
  DEFAULT: '*',
  MAX_XL: breakpointPrefixes.MAX_XL,
  MAX_MD: breakpointPrefixes.MAX_MD,
};

// Ordered from the widest breakpoint to the narrowest, as the cascade relies on it
const breakpoints = [
  { key: breakpointKeys.DEFAULT, prefix: null },
  { key: breakpointKeys.MAX_XL, prefix: breakpointPrefixes.MAX_XL },
  { key: breakpointKeys.MAX_MD, prefix: breakpointPrefixes.MAX_MD },
];

const breakpointKeyByPrefix = Object.fromEntries(
  breakpoints.filter(({ prefix }) => prefix !== null).map(({ key, prefix }) => [prefix, key])
);

const breakpointPrefixByKey = Object.fromEntries(
  breakpoints.map(({ key, prefix }) => [key, prefix])
);

const widerBreakpointKeys = Object.fromEntries(
  breakpoints.map(({ key }, index) => [key, breakpoints.slice(0, index).map((bp) => bp.key)])
);

const narrowerBreakpointKeys = Object.fromEntries(
  breakpoints.map(({ key }, index) => [key, breakpoints.slice(index + 1).map((bp) => bp.key)])
);

const cascadeBreakpointKeys = Object.fromEntries(
  breakpoints.map(({ key }, index) => [
    key,
    Array.from({ length: index + 1 }, (_, offset) => breakpoints[index - offset].key),
  ])
);

export default breakpoints;
export {
  breakpointPrefixes,
  breakpointKeys,
  breakpointKeyByPrefix,
  breakpointPrefixByKey,
  widerBreakpointKeys,
  narrowerBreakpointKeys,
  cascadeBreakpointKeys,
};
